import React from 'react';

const LoadingSkeleton = ({ type = 'carousel' }) => {
  if (type === 'hero') {
    return (
      <div className="h-96 md:h-[500px] lg:h-[600px] bg-muted rounded-xl animate-pulse">
        <div className="h-full flex items-center">
          <div className="container mx-auto px-4 lg:px-8">
            <div className="max-w-2xl space-y-4">
              <div className="flex space-x-2">
                <div className="h-6 w-20 bg-muted-foreground/20 rounded"></div>
                <div className="h-6 w-16 bg-muted-foreground/20 rounded"></div>
              </div>
              <div className="h-12 w-3/4 bg-muted-foreground/20 rounded"></div>
              <div className="h-4 w-1/2 bg-muted-foreground/20 rounded"></div>
              <div className="space-y-2">
                <div className="h-4 w-full bg-muted-foreground/20 rounded"></div>
                <div className="h-4 w-5/6 bg-muted-foreground/20 rounded"></div>
              </div>
              <div className="flex space-x-3">
                <div className="h-10 w-24 bg-muted-foreground/20 rounded"></div>
                <div className="h-10 w-24 bg-muted-foreground/20 rounded"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (type === 'carousel') {
    return (
      <div className="mb-8">
        <div className="flex items-center justify-between mb-4">
          <div className="h-8 w-48 bg-muted rounded animate-pulse"></div>
          <div className="h-6 w-20 bg-muted rounded animate-pulse"></div>
        </div>
        <div className="flex space-x-4 overflow-hidden">
          {[...Array(6)].map((_, index) => (
            <div key={index} className="w-40 sm:w-48 md:w-52 flex-shrink-0">
              <div className="bg-muted rounded-lg overflow-hidden animate-pulse">
                <div className="h-24 sm:h-28 md:h-32 bg-muted-foreground/20"></div>
                <div className="p-3 space-y-2">
                  <div className="h-4 w-3/4 bg-muted-foreground/20 rounded"></div>
                  <div className="h-3 w-1/2 bg-muted-foreground/20 rounded"></div>
                  <div className="flex space-x-1">
                    <div className="h-5 w-12 bg-muted-foreground/20 rounded"></div>
                    <div className="h-5 w-16 bg-muted-foreground/20 rounded"></div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (type === 'filters') {
    return (
      <div className="mb-6 space-y-4 animate-pulse">
        <div className="flex space-x-2">
          <div className="h-6 w-16 bg-muted rounded"></div>
          {[...Array(4)].map((_, index) => (
            <div key={index} className="h-8 w-20 bg-muted rounded"></div>
          ))}
        </div>
        <div className="space-y-3">
          <div className="h-4 w-12 bg-muted rounded"></div>
          <div className="flex flex-wrap gap-2">
            {[...Array(8)].map((_, index) => (
              <div key={index} className="h-8 w-16 bg-muted rounded"></div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  return null;
};

export default LoadingSkeleton;